<template>
  <div class="report-menu mobile-hide">
    <div class="top-container text-white">
      <div class="item-title">
        <h3>Reports</h3>
      </div>
      <router-link tag="div" to="/report/performance" class="item-report mt-3" :class="{ activereport : $route.name == 'Report-Performance' }">
        <span>Performance</span>
      </router-link>
      <router-link tag="div" to="/report/feedback-comments" class="item-report" :class="{ activereport : $route.name == 'Report-feedback-comments' }">
        <span>Comments</span>
      </router-link>
      <router-link tag="div" to="/report/engagement" class="item-report" :class="{ activereport : $route.name == 'Report-engagement' }">
        <span>Engagement</span>
      </router-link>
      <router-link tag="div" to="/report/daily-traffic" class="item-report" :class="{ activereport : $route.name == 'Report-dailyTraffic' }">
        <span>Daily Traffic</span>
      </router-link>
      <router-link tag="div" to="/report/hourly-traffic" class="item-report" :class="{ activereport : $route.name == 'Report-hourlyTraffic' }">
        <span>Hourly Traffic</span>
      </router-link>
      <!-- <router-link tag="div" to="/report/daily-traffic" class="item-report">
        <span>Battery Life</span>
      </router-link> -->
    </div>
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway'

/* eslint-disable */
export default {
  mixins: [ clickaway ],

  data: function () {
    return {
      contentStatus: ''
    }
  },
  mounted () {
    console.log('sidebar mounted 2')
  },
  methods: {

  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/layouts/menus/ReportMenu.vue